import type { TabsProps } from "@mui/material";
import { Tabs } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

import variables from "../../../assets/styles/_variables.module.scss";
const STabs = styled((props: TabsProps) => <Tabs {...props} />)(({ theme }) => ({
    "&.MuiTabs-root": {
        borderBottom: `1px solid ${variables["border-grey"]}`,
        ".MuiTabs-scroller": {
            ".MuiTabs-flexContainer": {
                ".MuiButtonBase-root": {
                    textTransform: "none",
                    fontSize: "14px",
                    marginRight: "40px",
                    fontFamily: "Poppins",
                    fontWeight: 400,
                },
                ".Mui-selected": {
                    color: "#000000",
                    fontSize: "14px",
                    fontWeight: 400,
                },
            },
        },
        ".MuiTabs-indicator": {
            borderBottom: "3px solid #000000",
            background: "none",
        },
    },
}));

export function StyledTabs(props: Partial<TabsProps>) {
    return <STabs {...props} />;
}
